// @ts-nocheck
import { VALIDATE_LOGIN_ERROR, VALIDATE_LOGIN_LOADING, VALIDATE_LOGIN_SUCCESS} from "../Type";
import * as Authservices from '../../Services/services';

export const validateLogin = (data) => {
    return (dispatch) => {
        return new Promise((resolve, reject) => {
            dispatch({
                type: VALIDATE_LOGIN_LOADING,
                data: true
            })
            Authservices.validateLogin(data).then((data) => {
                if (!data) {
                    return resolve({ status: 401 });
                }
                if (data?.status === 200) {
                    dispatch({
                        type: VALIDATE_LOGIN_SUCCESS,
                        data: data?.data
                    })
                    return resolve(data?.data);
                }
            }).catch((error) => {
                if (error) {
                    // For new users or invalid JSON, pass through the error
                    if (error.response && (error.response.status === 404 || error.response.status === 400)) {
                        dispatch({
                            type: VALIDATE_LOGIN_ERROR,
                            data: error.response
                        })
                        return reject(error.response);
                    }
                    // For other errors, show generic message
                    const errorMessage = {
                        message: 'An unexpected error (' + (error.response ? error.response.status : 'Network Error') + ') has occurred and AvSight Support has been notified. Please reload the screen and try again.'
                    };
                    dispatch({
                        type: VALIDATE_LOGIN_ERROR,
                        data: errorMessage
                    })
                    return reject(errorMessage);
                }
            })
        })
    }
}